import ContentLoader from 'react-content-loader'
import { Box } from 'theme-ui'
import { Paper } from 'components'

export const StudentFormContentLoader = (props: any) => {
  const random = Math.random() * (1 - 0.7) + 0.7
  return (
    <Box sx={{ width: '100%' }}>
      <Paper sx={{ position: 'relative' }} withShadow>
        <ContentLoader
          height={800}
          width="100%"
          speed={2}
          foregroundColor="#d9d9d9"
          backgroundColor="#ecebeb"
          {...props}>
          <rect x={0} y="45" rx="3" ry="3" width={200 * random} height={30} />
          <rect x={0} y="83" rx="3" ry="3" width={500} height={48} />

          <rect x={0} y="183" rx="3" ry="3" width={80} height={20} />
          <rect x={0} y="218" rx="3" ry="3" width={85} height={48} />
          <rect x={100} y="218" rx="3" ry="3" width={85} height={48} />
          <rect x={200} y="218" rx="3" ry="3" width={85} height={48} />
          <rect x={545} y="183" rx="3" ry="3" width={85} height={20} />
          <rect x={545} y="218" rx="3" ry="3" width={500} height={48} />

          <rect x={0} y="318" rx="3" ry="3" width={80} height={20} />
          <rect x={0} y="353" rx="3" ry="3" width={500} height={48} />
          <rect x={545} y="318" rx="3" ry="3" width={85} height={20} />
          <rect x={545} y="353" rx="3" ry="3" width={500} height={48} />

          <rect x={0} y="453" rx="3" ry="3" width={80} height={20} />
          <rect x={0} y="488" rx="3" ry="3" width={500} height={48} />
          <rect x={545} y="453" rx="3" ry="3" width={85} height={20} />
          <rect x={545} y="488" rx="3" ry="3" width={85} height={48} />
          <rect x={650} y="488" rx="3" ry="3" width={85} height={48} />
          <rect x={755} y="488" rx="3" ry="3" width={85} height={48} />

          <rect x={0} y="588" rx="3" ry="3" width={80} height={20} />
          <rect x={0} y="623" rx="3" ry="3" width={500} height={48} />
          <rect x={545} y="588" rx="3" ry="3" width={85} height={20} />
          <rect x={545} y="623" rx="3" ry="3" width={150} height={48} />
          <rect x={710} y="623" rx="3" ry="3" width={330} height={48} />
        </ContentLoader>
      </Paper>
    </Box>
  )
}
